export class ReportsDataModel {

    reportsDateRangeModel = {
        start: null,
        end: null
    };

    withoutPaginationReportsGridModel = {
        data: [],
        total: 0
    };

    paginationReportsGridModel = {
        items: [],
        isEmpty: false,
        isNotEmpty: true,
        currentPage: 0,
        resultsPerPage: 0,
        totalPages: 0,
        totalResults: 0
    };

    royaltyReportCreateDataModel = {
        totalShipping: null,
        totalPackaging: null,
        totalInsurance: null,
        totalService: null,
        totalOthers: null,
        totalGross: null,
        totalShippingOriginal: null,
        totalPackagingOriginal: null,
        totalInsuranceOriginal: null,
        totalServiceOriginal: null,
        totalOthersOriginal: null,
        totalGrossOriginal: null,
        totalOrderCount: null,
        lessNonRevenueDeliveries: null,
        lessHardCasesCOGS: null,
        lessHardCasesTaxes: null,
        lessTaxesPaid: null,
        lessNonStandardDeductions: null,
        totalAdjustedGross: null,
        adjustedRoyaltyFee: null,
        adjustedAdFund: null,
        royaltyFee: null,
        royaltyFeeRate: null,
        adFund: null,
        lateFeeRoyalty: null,
        lateFeeAdFund: null,
        monthRange: null,
        signature: null

    };

    insuranceReportTotals = {
        totalItemsPremium: 0,
        totalItemsValue: 0,
        totalLaborPremium: 0,
        totalLaborValue: 0,
        totalMaterialsPremium: 0,
        totalMaterialsValue: 0,
        totalServicePremium: 0,
        totalServiceValue: 0,
        totalShippingPremium: 0,
        totalShippingValue: 0,
        totalTotalPremium: 0,
        totalTotalValue: 0
    };

    insuranceExcessValueTotals = {
        totalItemsPremium: 0,
        totalItemsValue: 0,
        totalMaterialsPremium: 0,
        totalMaterialsValue: 0,
        totalServicePremium: 0,
        totalServiceValue: 0,
        totalShippingPremium: 0,
        totalShippingValue: 0,
        totalTotalPremium: 0,
        totalTotalValue: 0
    };

}
